export const ru = {
    'action-add': 'добавить',
    'action-cancel': 'отмена',
    'error-text':
        'Имя продукта должно состоять только из латинских букв и символов: "-" и "_".',
    'product-description-label': 'описание продукта',
    'product-name-label': 'название продукта'
};
